import { createContext, useContext, useEffect, useState } from 'react';

export const SKELETON_DELAY_MS = 500;
const SkeletonVisible = createContext(false);

/** One buffer per loading boundary; nested shapes appear together. */
export default function SkeletonDelay({ children }) {
  const inherited = useContext(SkeletonVisible);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (inherited) return;
    const timer = setTimeout(() => setReady(true), SKELETON_DELAY_MS);
    return () => clearTimeout(timer);
  }, [inherited]);
  if (!inherited && !ready) return null;
  return <SkeletonVisible.Provider value>{children}</SkeletonVisible.Provider>;
}
